import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import { postForm, patchForm } from '../../ajax'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import _ from 'lodash'

const CsrForm = ({csr, onClose, onError, onCreate, onUpdate}) => {
  useEffect(() => {
    if (csr) reset(_.omit(csr, 'id', 'created_at', 'updated_at'))
  }, [csr])

  const schema = yup.object({
    first_name: yup.string().trim().required('Required field')
      .max(100, 'Line is too long').nullable(),
    last_name: yup.string().trim().required('Required field')
      .max(100, 'Line is too long').nullable(),
    email: yup.string().required('Required field')
      .email('Wrong format')
      .max(100, 'Line is too long').nullable(),
    password: yup.string().trim().required('Required field')
      .max(40, 'Line is too long').nullable(),
    password_confirmation: yup.string().trim().required('Required field')
      .oneOf([yup.ref('password'), null], 'Passwords not match')
      .max(40, 'Line is too long').nullable()
  })

  const { register, reset, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  })

  const prepareFormData = data => {
    let formData = new FormData()
    for (const key in data) formData.append(`customer_service_rep[${key}]`, data[key])
    return formData
  }

  const onSubmit = data => {
    const formMethod = csr ? patchForm : postForm
    const submitUrl = csr ? `/admins/customer_service_reps/${csr.id}` : '/admins/customer_service_reps'
    const formData = prepareFormData(data)

    formMethod(submitUrl, formData)
    .then(response => { return response.json() })
    .then((json) => {
      if (json.error) return onError(json.error)
      csr ? onUpdate(json.csr) : onCreate(json.csr)
    })
  }

  return (
    <Modal container={document.body} show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Customer Service Rep</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className='new_user' onSubmit={handleSubmit(onSubmit)}>
          <div className='form-group'>
            <label htmlFor='first_name'>First name</label>
            <input
              {...register('first_name')}
              id='first_name'
              className='form-control'
              type='text'
            />
            { errors && errors.first_name && <span className='error'>{errors.first_name.message}</span> }
          </div>
          <div className='form-group'>
            <label htmlFor='last_name'>Last name</label>
            <input
              {...register('last_name')}
              id='last_name'
              className='form-control'
              type='text'
            />
            { errors && errors.last_name && <span className='error'>{errors.last_name.message}</span> }
          </div>
          <div className='form-group'>
            <label htmlFor='email'>Email</label>
            <input
              {...register('email')}
              id='email'
              className='form-control'
              type='text'
            />
            { errors && errors.email && <span className='error'>{errors.email.message}</span> }
          </div>
          <div className='form-group'>
            <label htmlFor='password'>Password</label>
            <input
              {...register('password')}
              id='password'
              className='form-control'
              type='password'
            />
            { errors && errors.password && <span className='error'>{errors.password.message}</span> }
          </div>
          <div className='form-group'>
            <label htmlFor='password_confirmation'>Password confirmation</label>
            <input
              {...register('password_confirmation')}
              id='password_confirmation'
              className='form-control'
              type='password'
            />
            { errors && errors.password_confirmation && <span className='error'>{errors.password_confirmation.message}</span> }
          </div>
          <Modal.Footer>
            <button className='btn btn-default' onClick={onClose} type='button'>Cancel</button>
            <input type='submit' value='Save Customer Service Rep' className='btn btn-success' />
          </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

export default CsrForm
